export const stopPropagation: React.MouseEventHandler = event => event.stopPropagation();
